module.exports = __webpack_public_path__ + "static/media/store_filled.e3068360.svg";